// extracted by mini-css-extract-plugin
export default {"user":"UserPanel_user_s7IOE","userName":"UserPanel_userName_wUu6A","logout":"UserPanel_logout_E6XoD","logoutIcon":"UserPanel_logoutIcon_uwXTH","line":"UserPanel_line_BQiR6"};